import { db, put, post, remove, URL } from 'utils';
import { fetch } from './fetch';

export const SET_GROUP = 'GROUP.SET_GROUP';
export const CREATE = 'GROUP.CREATE';
export const JOIN = 'GROUP.JOIN';
export const UPDATE = 'GROUP.UPDATE';
export const UPLOAD_AVATAR = 'GROUP.UPLOAD_AVATAR';

export const OPERATE_USER = 'GROUP.OPERATE_USER';
export const LEAVE = 'GROUP.LEAVE';
// We currently do not have this funcitonality implemented.
export const REMOVE = 'GROUP.REMOVE';
// We currently do not have this funcitonality implemented.
export const CLOSE = 'GROUP.CLOSE';

export const MAKE_ADMIN = 'GROUP.MAKE_ADMIN';
export const UNMAKE_ADMIN = 'GROUP.UNMAKE_ADMIN';
export const REMOVE_MEMBER = 'GROUP.REMOVE_MEMBER';
export const UNBLOCK_MEMBER = 'GROUP.UNBLOCK_MEMBER';
export const LEAVE_GROUP = 'GROUP.LEAVE_GROUP';
export const LOAD_TASKS = 'GROUP.LOAD_TASKS';
export const ADD_TASKS = 'GROUP.ADD_TASKS';
export const REMOVE_TASKS = 'GROUP.REMOVE_TASKS';
export const UPDATE_TASKS = 'GROUP.UPDATE_TASKS';
export const LOAD_SUBMISSIONS = 'GROUP.LOAD_SUBMISSIONS';
export const ADD_SUBMISSIONS = 'GROUP.ADD_SUBMISSIONS';
export const REMOVE_SUBMISSIONS = 'GROUP.REMOVE_SUBMISSIONS';
export const REMOVE_SUBMISSION = 'GROUP.REMOVE_SUBMISSION';
export const SUBMIT = 'GROUP.SUBMIT';

export const LOAD_MATERIALS = 'GROUP.LOAD_MATERIALS';
export const ADD_MATERIALS = `GROUP.ADD_MATERIALS`;
export const REMOVE_MATERIALS = `GROUP.REMOVE_MATERIALS`;
export const UPDATE_MATERIALS = 'GROUP.UPDATE_MATERIALS';
export const CLOSE_GROUP = 'GROUP.CLOSE_GROUP';
export const OPEN_GROUP = 'GROUP.OPEN_GROUP';
// export const OPERATE_ANNOUNCEMENT = {
//   put: UPDATE_ANNOUNCEMENT,
//   remove: REMOVE_ANNOUNCEMENT,
//   post: ADD_ANNOUNCEMENT
// };

export const create = ({ title, description }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.GROUPS, method: post, params: { title, description } };
  fetch(request, CREATE);
};

export const join = secret => (dispatch, getState) => {
  const request = { url: URL.GROUP.JOIN(secret), method: post };
  fetch(request, JOIN);
};

export const update = ({ group_id, title, description }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.UPDATE(group_id), method: put, params: { title, description } };
  fetch(request, UPDATE);
};

export const uploadAvatar = ({ upload, group_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.UPLOAD_AVATAR(group_id), method: put, params: { upload } };
  fetch(request, UPLOAD_AVATAR);
};

export const getTasks = group_id => (dispatch, getState) => {
  const dispatchLW = type => data => dispatch({ type, payload: { id: group_id, data } });
  const once = dispatchLW(LOAD_TASKS);
  const added = dispatchLW(ADD_TASKS);
  const changed = dispatchLW(UPDATE_TASKS);
  const removed = dispatchLW(REMOVE_TASKS);

  db.loadAndWatch(`convs/${group_id}/tasks`, { once, added, changed, removed });
};

export const addTask = (task, selected) => (dispatch, getState) => {
  const request = { url: URL.GROUP.ADD_TASK(selected), method: post, params: task };
  fetch(request, ADD_TASKS);
};

export const updateTask = (task, task_id, group_id) => (dispatch, getState) => {
  task.id = task_id;
  const request = { url: URL.GROUP.UPDATE_TASK(group_id, task_id), method: put, params: task };
  fetch(request, UPDATE_TASKS);
};

export const removeTask = ({ group_id, task_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.REMOVE_TASK(group_id, task_id), method: remove };
  fetch(request, REMOVE);
};

export const closeGroup = ({ group_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.CLOSE_GROUP(group_id), method: put };
  fetch(request, CLOSE_GROUP);
};

export const openGroup = ({ group_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.OPEN_GROUP(group_id), method: put };
  fetch(request, OPEN_GROUP);
};

export const makeAdmin = ({ member_id, conv_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.MAKE_ADMIN(conv_id), method: put, params: { member_id } };
  fetch(request, MAKE_ADMIN);
};

export const unmakeAdmin = ({ member_id, conv_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.UNMAKE_ADMIN(conv_id), method: put, params: { member_id } };
  fetch(request, UNMAKE_ADMIN);
};

export const removeMember = ({ member_id, conv_id, reason, role, report }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.REMOVE_MEMBER(conv_id), method: put, params: { member_id, reason, role, report } };
  fetch(request, REMOVE_MEMBER);
};

export const unblockMember = ({ member_id, conv_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.UNBLOCK_MEMBER(conv_id), method: put, params: { member_id, conv_id } };
  fetch(request, UNBLOCK_MEMBER);
};

export const leaveGroup = ({ member_id, conv_id, role }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.LEAVE_GROUP(conv_id), method: put, params: { member_id, role } };
  fetch(request, LEAVE_GROUP);
};

export const operateUser = ({ group_id, user_id, action, payload }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.USER(group_id, user_id), method: put, params: { action, payload } };
  fetch(request, OPERATE_USER);
};

export const leave = group_id => (dispatch, getState) => {
  const request = { url: URL.GROUP.LEAVE(group_id), method: remove };
  fetch(request, LEAVE);
};

export const removeGroup = group_id => (dispatch, getState) => {
  console.log(`group.remove, was not et implemented`);
  const request = { url: URL.GROUP.GROUP(group_id), method: remove };
  fetch(request, REMOVE);
};

export const close = group_id => (dispatch, getState) => {
  console.log(`group.close is not yet implemented.`);
};

export const addMaterial = ({ upload, group_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.ADD_MATERIAL(group_id), method: post, params: { files: upload } };
  fetch(request, ADD_MATERIALS);
};

export const removeMaterial = ({ upload_id, group_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.REMOVE_MATERIAL(group_id, upload_id), method: remove };
  fetch(request, REMOVE_MATERIALS);
};

export const getMaterials = group_id => (dispatch, getState) => {
  const once = once => dispatch({ type: LOAD_MATERIALS, payload: { id: group_id, data: once } });
  const added = added => dispatch({ type: ADD_MATERIALS, payload: { id: group_id, data: added } });
  const changed = changed => dispatch({ type: UPDATE_MATERIALS, payload: { id: group_id, data: changed } });
  const removed = removed => dispatch({ type: REMOVE_MATERIALS, payload: { id: group_id, data: removed } });

  db.loadAndWatch(`convs/${group_id}/materials`, { once, added, changed, removed });
};

export const submit = ({ upload, conv_id, task_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.SUBMISSION(conv_id, task_id), params: { files: upload }, method: post };
  fetch(request, SUBMIT);
};

export const deleteSubmission = ({ conv_id, task_id }) => (dispatch, getState) => {
  const request = { url: URL.GROUP.SUBMISSION(conv_id, task_id), method: remove };
  fetch(request, REMOVE_SUBMISSION);
};

export const getSubmissions = ({ group_id, id, type }) => (dispatch, getState) => {
  type = type || 'members';
  const key = type === 'members' ? 'task_id' : 'user_id';
  const once = once => dispatch({ type: LOAD_SUBMISSIONS, payload: { id: group_id, data: once } });
  const added = added => dispatch({ type: ADD_SUBMISSIONS, payload: { id: group_id, data: added, key } });
  const removed = removed => dispatch({ type: REMOVE_SUBMISSIONS, payload: { id: group_id, data: removed, key } });

  db.loadAndWatch(`convs/${group_id}/submissions/${type}/${id}`, { once, added, removed });
};

export const stopSubmissionWatch = ({ conv_id, task_id }) => (dispatch, getState) => {
  db.off(`convs/${conv_id}/submissions/admins/${task_id}`);
};



// WEBPACK FOOTER //
// ./src/actions/group.js